// just return all state
export const getAllstate = state => state

// loading state
export const getLoading = state => state.loading

// Language
export const getLanguage = state => state.lang

// Size
export const getSize = state => state.size

// User
export const getUser = state => {
  return state.user
}

// count state
export const getCount = state => state.loadCount

// count state
export const getAppId = state => state.appId

// count state
export const getPageId = state => state.pageId

// count state
export const getReSetFg = state => state.reSetFg

// count state
export const getReSetFg2 = state => state.reSetFg2
